// 新しい作る画面の入口（2026-10-21 に app.js を役割ごとのモジュールに分けた。tools/chibi-unify/build-ui.mjs で app.min.js にまとめてページが読む）
/*
 * CHOCO の作成画面（2026-10-10 にモック mockups/choco-ui として作り、2026-10-12 に chibi/create/ へ）。操作部分は HTML、キャラは SVG。
 *
 * データは本物と同じ getcategory.php（カテゴリ・レイヤー・カテゴリ画像 SWITCH・パレット・プリセット CHARA・パーツ CACHE）。
 * カテゴリボタンとパーツのサムネイルは、今のエンジンと同じく SVG から g を取り出して作る:
 *   - カテゴリボタン: SWITCH（switch_chibi.svg）の直下の g#{ALIAS か NAME}
 *   - サムネイル: パーツの SVG の直下の g（id の頭が x / a / y、続く4桁がパーツ番号）を、カテゴリの TGLAYER の順に重ね、
 *     ICON（[横の寄せ, 縦の寄せ, 拡大]）と REVERSE で 500 四方から切り出す（chibi.setPartsList の ptransform と同じ）
 * キャラの組み立て・色・グラデーション・移動・拡大・反転も、エンジン（makeCharactor・changeColor・changeGradColor・moveG・zoomG・reverseG）と同じ計算。
 * 保存データ（{v, n, c}）も同じ形で読み書きする。保存場所も前の画面（chibi/create/legacy.php）と同じ（localStorage の chibi_auto・chibi_save、IndexedDB のスロット）。
 * 画面（2026-10-10 第2版）: ボタンはキャラの上に浮かせて行を取らない（右上にランダム・セーブ・完成、右端に選んだカテゴリの調整）。
 *   移動は十字キー（長押しで続けて）とキャラの上のドラッグ。スマホのパーツは下から出るシートで、つまみで広げる・戻す。
 *   ランダム・プリセットの読み込みは確認を出さず、「元に戻す」付きのお知らせを出す。
 */
import './config.js';
import './text.js';
import './merge.js';
import './store.js';
import './util.js';
import './colormath.js';
import './core/pattern.js';
import './core/data.js';
import './stage.js';
import './lookrules.js';
import './core/savedata.js';
import './categories.js';
import './colors.js';
import './colorlink.js';
import './lr.js';
import './picker.js';
import './palette.js';
import './parts.js';
import './tools.js';
import './pointer.js';
import './partbox.js';
import './frame.js';
import './view.js';
import './random.js';
import './history.js';
import './sheet.js';
import './storage.js';
import './slots.js';
import './importimage.js';
import './name.js';
import './finish.js';
import './shutter.js';
import './download.js';
import './kira.js';
import './dialog.js';
import './compat.js';
import './agree.js';
import './tour.js';
import './boot.js';
import { C } from './core/model.js';
import { partIsEmpty, partsList } from './core/data.js';
import { saveObject } from './core/savedata.js';
import { loadSave as applySave } from './loadsave.js';
import { NAME_FONT, nameImage } from './name.js';
import { downloadFinished, saveZip } from './download.js';
import { carryText } from './storage.js';
import { S } from './state.js';
import { on } from './core/events.js';
import { keyOf } from './core/util.js';
import { start } from './boot.js';
// 外から使う窓口。host は完成画面の共通部品 additional.js が使うもの（2026-10-21〜。前は page.php が window.chibi・charat.common の代役を置いていた）:
//   saveText 画像に埋め込む圧縮データ（Promise）、carryText アプリ内ブラウザから開き直す URL に載せる圧縮データ（すぐに返す）、font クレジットの書体
// ほかは確かめる用（前の画面のエンジンと同じ保存データを読み書きする）と、完成画面のアニメ（emote.js）・広場（avatar.js）が使うもの
window.charatCreate = { applySave: applySave, saveObject: saveObject, saveZip: saveZip, presets: () => C.data.CHARA,
  downloadFinished: downloadFinished, nameImage: nameImage, partsList: partsList, partIsEmpty: partIsEmpty,
  partSvg: (name: string) => (C.partsCache[name] ? C.partsCache[name].SVG : null),
  // キャラが変わったとき（描き直し・位置の付け直し）・選んでいるカテゴリ・移動中か（作る画面のキャラを動かす emote.js の initStageEmote が使う。2026-10-28）
  onChange: (fn: (why: string, key: string) => void) => {
    on('drawn', (cat, _st, why) => fn(why, keyOf(cat)));
    on('placed', (cat, _st, why) => fn(why, keyOf(cat)));
    on('drawnAll', (why) => fn(why, ''));
  },
  selected: () => S.selKey || '',
  moving: () => !!S.moveMode,
  host: { saveText: saveZip, carryText: carryText, font: NAME_FONT } };
start();
